import { render, staticRenderFns } from "./ResultCollaboration.vue?vue&type=template&id=2d6bc7c8&"
import script from "./ResultCollaboration.vue?vue&type=script&lang=js&"
export * from "./ResultCollaboration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports